var map = {
	"./audio-placeholder": 756,
	"./audio-placeholder.png": 756,
	"./avatar-missing": 578,
	"./avatar-missing.png": 578,
	"./avatar-missing.svg": 954,
	"./halloween/clouds": 757,
	"./halloween/clouds.png": 757,
	"./halloween/halloween-emblem": 767,
	"./halloween/halloween-emblem.svg": 767,
	"./halloween/spider": 768,
	"./halloween/spider.svg": 768,
	"./halloween/spiderweb": 769,
	"./halloween/spiderweb.svg": 769,
	"./halloween/starfield": 770,
	"./halloween/starfield.png": 770,
	"./halloween/twinkle": 771,
	"./halloween/twinkle.svg": 771,
	"./header-missing": 583,
	"./header-missing.png": 583,
	"./reticle": 772,
	"./reticle.png": 772,
	"./soapbox-logo": 584,
	"./soapbox-logo-white": 585,
	"./soapbox-logo-white.svg": 585,
	"./soapbox-logo.svg": 584,
	"./sprite-post-functions": 773,
	"./sprite-post-functions.png": 773,
	"./video-placeholder": 774,
	"./video-placeholder.png": 774,
	"./void": 775,
	"./void.png": 775,
	"./web-push/web-push-icon_expand": 806,
	"./web-push/web-push-icon_expand.png": 806,
	"./web-push/web-push-icon_favourite": 807,
	"./web-push/web-push-icon_favourite.png": 807,
	"./web-push/web-push-icon_reblog": 808,
	"./web-push/web-push-icon_reblog.png": 808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 953;